// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YMwI","title":"Header_title__16-vk","left":"Header_left__3Jpk9","clinicName":"Header_clinicName__WTpF2"};